import { Component } from '@angular/core';

@Component({
    selector: 'portlet',
    templateUrl: './portlet.component.html',
    inputs: ["title", "subtitle"]
})
export class PortletComponent {
}

@Component({
    selector: "portlet-footer-left",
    template: '<ng-content></ng-content>',
    // inputs: ["icon"]
})
export class PortletFooterLeftComponent {

}

@Component({
    selector: "portlet-footer-right",
    template: ' <ng-content></ng-content>',
    //  inputs: ["icon"]
})
export class PortletFooterRightComponent {

}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/custom-component/portlet.component.ts